//
//
//
//
//
//
//
//
//
//

import PageMixin from '~/mixins/page'

export default {
  mixins: [
    PageMixin
  ],
  layout: 'empty',
  head () {
    return {
      ...this.createSeoTags({
        title: this.$t('giveaway.seo.title'),
        description: this.$t('giveaway.seo.description'),
        url: 'https://get-base.com/giveaway',
        link: [
          {
            rel: 'preload',
            as: 'image',
            type: 'image/svg+xml',
            href: this.getStaticsObject('/icons/icon_arrow_right_black.svg')
          },
          {
            rel: 'preload',
            as: 'image',
            type: 'image/svg+xml',
            href: this.getStaticsObject('/giveaway/total_value.svg')
          }
        ]
      }),
      script: [
        { innerHTML: 'var vs_lightbox_start_off=true;' },
        { src: 'https://app.viralsweep.com/vsa-lightbox-4bb706-100356.js?sid=100356_590916', async: true }
      ],
      __dangerouslyDisableSanitizers: ['script']
    }
  }
}
